import { handleError } from '../utils/errorHandler';
import React, { useEffect, useState } from 'react';
import ArcGISMap from '@arcgis/core/Map';
import MapView from '@arcgis/core/views/MapView';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import UniqueValueRenderer from '@arcgis/core/renderers/UniqueValueRenderer';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import Graphic from "@arcgis/core/Graphic";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Color from "@arcgis/core/Color";
import { colorsRange, formatNumber, layerConfig, divipolas } from '../Transversal';
import { API_URL, COLOR_FONT_TITLE, HEIGHT_BODY } from '../Config';
import { DEFAULT_FILTER, ArcFiltros } from './SesionDetalles';
import { FaSort, FaDownload, FaEraser, FaUpload } from 'react-icons/fa';
import { reverse } from 'dns';
import { limpiarFiltros } from './HeaderDetalles';
import { Console } from 'console';
import { apiFetch } from '../apiClient';
import { useUrlParams } from '../hooks/useUrlParams';

interface MapaProps {
    setCodigoDivipola: (codigo: string) => void;
    filtrar: string;
    indicador: any,
    codigoDivipola: string;
}

class DivipolaCantidad {
    public codigoDivipola: string = "";
    public nombre: string = "";
    public cantidad: number = 0;
    public cantidadGlobal: number = 0;
    public cantidadInternos: number = 0;
}

let map: ArcGISMap;
let view: MapView;
let divipolaCantidad: DivipolaCantidad[] = [];
let listaCantidades: number[] = [];
let featureLayers: FeatureLayer[] = [];
let codigosDivipolasGrises: string[] = [];
let layerType: keyof typeof layerConfig = "departamentos";
let renderer = new UniqueValueRenderer();
let codDivipolaAnteriorPopup = "";
let zooming = false;
let layerView: __esri.FeatureLayerView;
let highlight: __esri.Handle | null = null;
const graphicsLayer = new GraphicsLayer();
let highlightGraphicAnterior: Graphic | null = null;
let rendererDefault = renderer = new UniqueValueRenderer({
    field: layerConfig[layerType].fieldCode,
    uniqueValueInfos: [],
    defaultSymbol: new SimpleFillSymbol({
        color: [255, 255, 255, 1],
        outline: {
            color: [211, 211, 211, 0.5],
            width: 1
        }
    })
});
let consecutivoReact = 0;

const MapaMain: React.FC<MapaProps> = ({ setCodigoDivipola, filtrar, indicador, codigoDivipola }) => {
    let cargado = false;
    const [showLayers, setShowLayers] = useState(false);
    const [pdetLayerVisible, setPdetLayerVisible] = useState(false);
    const [internosLayerVisible, setInternosayerVisible] = useState(false);
    
    // Capturar parámetros de URL
    const { primeraInfancia } = useUrlParams();

    const cargarCapaMapa = async (layerType: keyof typeof layerConfig, prefixCode: string) => {
        try {
            const startTime = performance.now();
            layerTypeOnLoad();
            const codigosDivipolaMostrar = divipolaCantidad.map(divipola => divipola.codigoDivipola);
            const featureLayer = new FeatureLayer({
                url: layerConfig[layerType].url,
                outFields: ["*"],
                renderer: renderer,
                labelingInfo: [{
                    labelExpressionInfo: {
                        expression: `
                            var maxPorLinea = 12;
                            var fieldCode = $feature.${layerConfig[layerType].fieldCode};
                            var fieldName = $feature.${layerConfig[layerType].fieldName};                                               
                            var line1 = Mid(fieldName, 0, maxPorLinea);
                            var line2 = Mid(fieldName, maxPorLinea*1, maxPorLinea ); 
                            var line3 = Mid(fieldName, maxPorLinea*2, maxPorLinea );
                            var line4 = Mid(fieldName, maxPorLinea*3, maxPorLinea );
                            var line5 = Mid(fieldName, maxPorLinea*4, maxPorLinea );
                            var codigosDivipolaMostrar = '${codigosDivipolaMostrar.join(",")}';
                            var isVisible = Find(fieldCode, codigosDivipolaMostrar) >= 0;
                            var labels = [line1, line2, line3, line4, line5];
                            return IIf(isVisible, Concatenate(labels, TextFormatting.NewLine), '');
                        `
                    },
                    symbol: {
                        type: "text",
                        color: COLOR_FONT_TITLE,
                        haloColor: "#cccccc",
                        haloSize: "1px",
                        font: {
                            size: 6,
                            family: "Arial",
                            weight: "bolder",
                        }
                    },
                }]
            });
            map.add(featureLayer);
            layerView = await view.whenLayerView(featureLayer);
            
            view.when(() => {
                crearBotonesZoom();
                featureLayers.push(featureLayer);
                const endTime = performance.now();
                const duration = endTime - startTime;
                console.log(`Mapa Fetch duration: ${duration} ms`);
                centerMap(view, featureLayer);
            }).catch((error) => {
                handleError(error);
            });
        } catch (error) {
            handleError(error);
        }
    }

    const fetchDatos = async () => {
        try {
            if (DEFAULT_FILTER.internos == "1") {
                setInternosayerVisible(true);
            }
            else {
                setInternosayerVisible(false);
            }
            const startTime = performance.now();
            const queryString = Object.keys(DEFAULT_FILTER)
                .filter(key => DEFAULT_FILTER[key as keyof ArcFiltros] !== undefined)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(DEFAULT_FILTER[key as keyof ArcFiltros] ?? '')}`)
                .join('&');
            const url = `${API_URL}/ArcIndicador/GetDivipolaCantidades?${queryString}`
            const response = await apiFetch(url);
            let data = await response.json();
            divipolaCantidad.length = 0;
            divipolaCantidad.push(...data);
            divipolaCantidad = divipolaCantidad.filter((divipola) => divipola.codigoDivipola != 'TOTAL' && divipola.codigoDivipola != 'DESAGREGACIÓN');
            listaCantidades = divipolaCantidad.filter((divipola) => {
                if (DEFAULT_FILTER.codigoDivipolaDpto !== "") {
                    return divipola.codigoDivipola.length === 5;
                }
                return true;
            }).filter((divipola) => divipola.codigoDivipola != 'TOTAL' && divipola.codigoDivipola != 'DESAGREGACIÓN').map((divipola) => divipola.cantidad);
            if (DEFAULT_FILTER.esPDET == "1") {
                setPdetLayerVisible(true);
            }
            else {
                setPdetLayerVisible(false);
            }

            zooming = false;
            const endTime = performance.now();
            const duration = endTime - startTime;
            console.log(`Fetch duration: ${duration} ms`);
        } catch (error) {
            handleError(error);
        }
    };

    const recargarDatos = async () => {
        cargado = false;
        fetchDatos().then(() => {
            if (!cargado) {
                cargado = true;
                updateRenderer();
                crearBotonesZoom();
            }
        });
    }

    const removeLayers = () => {
        featureLayers.forEach((featureLayer) => {
            if (map.layers.includes(featureLayer)) {
                map.remove(featureLayer);
            }
        });
        featureLayers.length = 0;
    }

    const deleteAllHighlights = () => {
        graphicsLayer.removeAll();
        view.graphics.removeAll();
    }

    const highlightDivipola = async (codigoDivipola: string) => {
        try {
            const featureLayer = featureLayers[0];
            // Obtener la vista de la capa para la capa de entidades
            const layerView = await view.whenLayerView(featureLayer);
            // Consultar la capa de entidades para obtener las entidades
            const query = featureLayer.createQuery();
            query.where = `${layerConfig[layerType].fieldCode} = '${codigoDivipola}'`;
            query.returnGeometry = true;
            featureLayer.queryFeatures(query).then((results) => {
                if (results.features.length > 0) {
                    // Crear el símbolo de resaltado amarillo
                    const highlightSymbol = {
                        type: "simple-fill" as const,
                        color: [255, 255, 153, 0.3],  // Amarillo más suave y bonito, semitransparente
                        outline: {
                            color: [255, 204, 0],  // Contorno amarillo más suave
                            width: 1.5
                        }
                    };
                    // Crear un gráfico de resaltado
                    highlightGraphicAnterior = new Graphic({
                        geometry: results.features[0].geometry,
                        symbol: highlightSymbol
                    });
                    // Añadir el gráfico de resaltado al GraphicsLayer
                    graphicsLayer.removeAll(); // Eliminar gráficos anteriores si es necesario
                    //graphicsLayer.add(highlightGraphicAnterior);
                    //add the graphic to the view
                    view.graphics.removeAll();
                    view.graphics.add(highlightGraphicAnterior);
                    mostrarPopupDivipola();
                }
            });
        }
        catch (error) {
            handleError(error);
        }
    };

    const mostrarPopupDivipola = () => {
        const featureLayer = featureLayers[0];
        if (DEFAULT_FILTER.codigoDivipolaMpio != "") {
            view.whenLayerView(featureLayer).then((layerView) => {
                const query = featureLayer.createQuery();
                query.where = `${layerConfig[layerType].fieldCode} = '${DEFAULT_FILTER.codigoDivipolaMpio}'`;
                query.returnGeometry = true;
                const divipola = divipolaCantidad.find(divipola => divipola.codigoDivipola === DEFAULT_FILTER.codigoDivipolaMpio);
                const nombredivipola = divipola?.nombre;
                /*
                const cantidadDivipola = formatNumber(divipola?.cantidad.toString() || 0);
                const cantidadInternos = formatNumber(divipola?.cantidadInternos.toString() || 0);
                let mostrarCantidadInternos = false;
                if (indicador.esFichaDepartamental == false) {
                    mostrarCantidadInternos = true;
                }
*/

                const cantidadInternos = formatNumber(divipola?.cantidadInternos.toString() || 0);
                let mostrarCantidadInternos = false;
                if (DEFAULT_FILTER.internos == "1") {
                    mostrarCantidadInternos = true;
                }
                let content = `<div class="custom-popup-content"></div>`;
                let labelCantidadMunicipios = '';
                if (mostrarCantidadInternos) {
                    labelCantidadMunicipios = `Cantidad Municipios con datos: <b>${cantidadInternos}</b>`;
                }
                if (DEFAULT_FILTER.tipoValor == 'N/A' || DEFAULT_FILTER.tipoValor == '') {
                    content = `<div class="custom-popup-content">${DEFAULT_FILTER.indicador}: <b>${formatNumber(divipola?.cantidad ?? 0)}</b><br/>${labelCantidadMunicipios}</b></div>`;
                } else {
                    content = `<div class="custom-popup-content">${DEFAULT_FILTER.tipoValor} <b>${formatNumber(divipola?.cantidad ?? 0)}</b><br/>${labelCantidadMunicipios}</b></div>`;
                }
                if (DEFAULT_FILTER.internos == "1") {
                    if(DEFAULT_FILTER.codigoDivipolaDpto == ""){
                        if (DEFAULT_FILTER.tipoValor == 'N/A' || DEFAULT_FILTER.tipoValor == '') {                                    
                            content = `<div class="custom-popup-content">${labelCantidadMunicipios}</b></div>`;
                        } else {
                            content = `<div class="custom-popup-content">${labelCantidadMunicipios}</b></div>`;
                        } 
                    }   
                    else{
                        if (DEFAULT_FILTER.tipoValor == 'N/A' || DEFAULT_FILTER.tipoValor == '') {                                    
                            content = `<div class="custom-popup-content">${DEFAULT_FILTER.indicador}: <b>${formatNumber(divipola?.cantidad ?? 0)}</div>`;
                        } else {
                            content = `<div class="custom-popup-content">${DEFAULT_FILTER.tipoValor} <b>${formatNumber(divipola?.cantidad ?? 0)}</div>`;
                        } 
                    }                            
                }



                
                featureLayer.queryFeatures(query).then((results) => {
                    if (results.features.length > 0) {
                        /*
                        view.popup.open({
                            location: results.features[0].geometry.extent.center,
                            title: `<div class="custom-popup-title">${nombredivipola}</div>`,
                            content: `<div class="custom-popup-content">
                                        ${DEFAULT_FILTER.tipoValor} <b>${formatNumber(cantidadDivipola)}</b>
                                        ${mostrarCantidadInternos ? `<br/>1. Cantidad Municipios: <b>${cantidadInternos}</b>` : ''}
                                      </div>`,
                        });
                        */

                        if (view.popup) {
                            view.openPopup({
                                //location: response.results[0].mapPoint,
                                title: `<div class="custom-popup-title">${nombredivipola}</div>`,
                                content: content,
                            });

                            view.popup.visibleElements = {
                                actionBar: false,
                                closeButton: true,
                                featureNavigation: true,
                            };
                            view.popup.alignment = "bottom-right";
                        }
                        codDivipolaAnteriorPopup = DEFAULT_FILTER.codigoDivipolaMpio;
                    }
                });
            });
        }
    };


    const eventsOnMap = () => {
        view.on("click", (event) => {
            if (view && view.popup && typeof view.popup.close === 'function') {
                view.popup.close();
            }
            view.hitTest(event).then((response) => {
                if (response.results.length > 0 && "graphic" in response.results[0]) {
                    const feature = response.results[0].graphic;
                    console.log(layerConfig[layerType].fieldName);
                    if (feature.attributes[layerConfig[layerType].fieldName]) {
                        const divipola = divipolaCantidad.find(divipola => Number(divipola.codigoDivipola) === Number(feature.attributes[layerConfig[layerType].fieldCode]));
                        if (divipola) {
                            if (layerType === "departamentos") {
                                DEFAULT_FILTER.codigoDivipolaDpto = divipola.codigoDivipola;
                                consecutivoReact++;
                                DEFAULT_FILTER.regrescarFiltros = DEFAULT_FILTER.regrescarFiltros + 1;
                                setCodigoDivipola(consecutivoReact.toString());
                                recargarDatos();
                            }
                            if (layerType === "municipios") {
                                DEFAULT_FILTER.codigoDivipolaMpio = divipola.codigoDivipola;
                                DEFAULT_FILTER.codigoDivipolaPdetMunicipio = divipola.codigoDivipola;
                                consecutivoReact++;
                                DEFAULT_FILTER.regrescarFiltros = DEFAULT_FILTER.regrescarFiltros + 1;
                                setCodigoDivipola(consecutivoReact.toString());
                                highlightDivipola(divipola.codigoDivipola);
                            }
                            if (layerType === "pdetregiones") {
                                DEFAULT_FILTER.codigoDivipolaPdetRegion = divipola.codigoDivipola;
                                DEFAULT_FILTER.regrescarFiltros = DEFAULT_FILTER.regrescarFiltros + 1;
                                consecutivoReact++;
                                setCodigoDivipola(consecutivoReact.toString());
                                recargarDatos();
                            }

                        }
                    }
                }
            });
        });
        view.on("mouse-wheel", (event) => {
            event.stopPropagation();
            view.hitTest(event).then((response) => {
                const deltaY = event.deltaY;
                if (deltaY < 0) {
                    view.zoom += 1;
                }
                else {
                    //zoomOut();

                }
            });
        });
        view.on("pointer-move", (event) => {
            view.hitTest(event).then((response) => {
                try {
                    if (response.results.length > 0 && "graphic" in response.results[0]) {
                        const feature = response.results[0].graphic;
                        if (feature.attributes && layerConfig[layerType].fieldName in feature.attributes) {
                            const divipola = divipolaCantidad.find(divipola => Number(divipola.codigoDivipola) === Number(feature.attributes[layerConfig[layerType].fieldCode]));
                            if (divipola && codDivipolaAnteriorPopup !== divipola.codigoDivipola) {
                                // Remover highlight anterior si existe
                                if (highlight) {
                                    highlight.remove();
                                }
                                // Crear nuevo highlight amarillo
                                highlight = layerView.highlight(feature);
                                
                                const cantidadInternos = formatNumber(divipola?.cantidadInternos.toString() || 0);
                                let mostrarCantidadInternos = false;
                                if (DEFAULT_FILTER.internos == "1") {
                                    mostrarCantidadInternos = true;
                                }
                                let content = `<div class="custom-popup-content"></div>`;
                                let labelCantidadMunicipios = '';
                                if (mostrarCantidadInternos) {
                                    labelCantidadMunicipios = `Cantidad Municipios con datos: <b>${cantidadInternos}</b>`;
                                }
                                if (DEFAULT_FILTER.tipoValor == 'N/A' || DEFAULT_FILTER.tipoValor == '') {
                                    content = `<div class="custom-popup-content">${DEFAULT_FILTER.indicador}: <b>${formatNumber(divipola.cantidad)}</b><br/>${labelCantidadMunicipios}</b></div>`;
                                } else {
                                    content = `<div class="custom-popup-content">${DEFAULT_FILTER.tipoValor} <b>${formatNumber(divipola.cantidad)}</b><br/>${labelCantidadMunicipios}</b></div>`;
                                }
                                if (DEFAULT_FILTER.internos == "1") {
                                    if(DEFAULT_FILTER.codigoDivipolaDpto == ""){
                                        if (DEFAULT_FILTER.tipoValor == 'N/A' || DEFAULT_FILTER.tipoValor == '') {                                    
                                            content = `<div class="custom-popup-content">${labelCantidadMunicipios}</b></div>`;
                                        } else {
                                            content = `<div class="custom-popup-content">${labelCantidadMunicipios}</b></div>`;
                                        } 
                                    }   
                                    else{
                                        if (DEFAULT_FILTER.tipoValor == 'N/A' || DEFAULT_FILTER.tipoValor == '') {                                    
                                            content = `<div class="custom-popup-content">${DEFAULT_FILTER.indicador}: <b>${formatNumber(divipola.cantidad)}</div>`;
                                        } else {
                                            content = `<div class="custom-popup-content">${DEFAULT_FILTER.tipoValor} <b>${formatNumber(divipola.cantidad)}</div>`;
                                        } 
                                    }                            
                                }
                                if (view.popup) {
                                    view.openPopup({
                                        //location: response.results[0].mapPoint,
                                        title: `<div class="custom-popup-title">${feature.attributes[layerConfig[layerType].fieldName]}</div>`,
                                        content: content,
                                    });
                                    view.popup.visibleElements = {
                                        actionBar: false,
                                        closeButton: true,
                                        featureNavigation: true,
                                        collapseButton: false
                                    };
                                    view.popup.alignment = "bottom-right";
                                }
                                codDivipolaAnteriorPopup = divipola.codigoDivipola;
                            }
                            if (view.container) {
                                view.container.style.cursor = "pointer"; // Cambia el cursor a pointer
                            }
                        }
                    } else {
                        // No hay features bajo el cursor, remover highlight y popup
                        if (highlight) {
                            highlight.remove();
                            highlight = null;
                        }
                        if (view && view.popup && typeof view.popup.close === 'function') {
                            view.popup.close();
                        }
                        if (view && view.container) {
                            view.container.style.cursor = "default"; // Restaurar cursor normal
                        }
                        codDivipolaAnteriorPopup = "";
                    }
                } catch (error) {
                    handleError(error);
                }
            }).catch((error) => {
                handleError(error);
            });
        });

        // Evento para cuando el mouse sale del contenedor del mapa
        view.container?.addEventListener("mouseleave", () => {
            if (highlight) {
                highlight.remove();
                highlight = null;
            }
            if (view && view.popup && typeof view.popup.close === 'function') {
                view.popup.close();
            }
            if (view && view.container) {
                view.container.style.cursor = "default";
            }
            codDivipolaAnteriorPopup = "";
        });
    }

    const layerTypeOnLoad = async () => {
        if (DEFAULT_FILTER.esPDET == "1") {
            if (DEFAULT_FILTER.codigoDivipolaPdetRegion == "") {
                layerType = "pdetregiones";
            }
            else {
                if (DEFAULT_FILTER.codigoDivipolaDpto == "") {
                    layerType = "departamentos";
                }
                if (DEFAULT_FILTER.codigoDivipolaDpto != "") {
                    layerType = "municipios";
                }
                if (DEFAULT_FILTER.codigoDivipolaMpio != "") {
                    highlightDivipola(DEFAULT_FILTER.codigoDivipolaMpio);
                    return;
                }
            }
        }
        else {
            if (DEFAULT_FILTER.codigoDivipolaDpto == "") {
                layerType = "departamentos";
            }
            if (DEFAULT_FILTER.codigoDivipolaDpto != "") {
                layerType = "municipios";
            }
        }
    }


    const updateRenderer = async () => {
        try {
            if (DEFAULT_FILTER.codigoDivipolaMpio == "") {
                removeLayers();
            }
            if (DEFAULT_FILTER.esPDET == "1") {
                if (DEFAULT_FILTER.codigoDivipolaPdetRegion == "") {
                    renderer = rendererDefault;
                    layerType = "departamentos";
                    await cargarCapaMapa(layerType, "D");
                    layerType = "pdetregiones";
                }
                else {
                    if (DEFAULT_FILTER.codigoDivipolaDpto == "") {
                        layerType = "departamentos";
                    }
                    if (DEFAULT_FILTER.codigoDivipolaDpto != "") {
                        layerType = "municipios";
                    }
                    if (DEFAULT_FILTER.codigoDivipolaMpio != "") {
                        highlightDivipola(DEFAULT_FILTER.codigoDivipolaMpio);
                        return;
                    }
                    else {
                        deleteAllHighlights();
                    }
                }
            }
            else {
                if (DEFAULT_FILTER.codigoDivipolaDpto == "") {
                    layerType = "departamentos";
                }
                if (DEFAULT_FILTER.codigoDivipolaDpto != "") {
                    layerType = "municipios";
                }
                if (DEFAULT_FILTER.codigoDivipolaMpio != "") {
                    highlightDivipola(DEFAULT_FILTER.codigoDivipolaMpio);
                    return;
                }
                else {
                    deleteAllHighlights();
                }
            }
            var todosCodigosDivipolas = ["", ""];
            var codigosDivipolasStr = divipolaCantidad.map(divipola => divipola.codigoDivipola);
            var codigosDivipolasInt = codigosDivipolasStr.map(Number);
            todosCodigosDivipolas = Array.from(new Set([...codigosDivipolasInt, ...codigosDivipolasStr])).map(String);
            codigosDivipolasGrises = divipolas
                .filter(divipola => divipola.Tipo === "Municipio" && divipola.CodigoDivipola.startsWith(DEFAULT_FILTER.codigoDivipolaDpto) && DEFAULT_FILTER.codigoDivipolaDpto !== "")
                .map(divipola => divipola.CodigoDivipola);
            var codigosDivipolasGrisesNotInTodos = codigosDivipolasGrises.filter(codigoDivipola => !todosCodigosDivipolas.includes(codigoDivipola));
            renderer = new UniqueValueRenderer({
                field: layerConfig[layerType].fieldCode,
                uniqueValueInfos:
                    divipolas.map((divipola, index) => {
                        var cantidad = 0;
                        var codigoDivipolaAux = divipola.CodigoDivipola;
                        if (divipola.CodigoDivipola.length === 1 || divipola.CodigoDivipola.length === 4) {
                            codigoDivipolaAux = `0${codigoDivipolaAux}`;
                        }
                        cantidad = divipolaCantidad.find(divipola => divipola.codigoDivipola === codigoDivipolaAux)?.cantidad || 0;
                        if (!divipolaCantidad.some(divipola => divipola.codigoDivipola === codigoDivipolaAux) && codigosDivipolasGrisesNotInTodos.includes(codigoDivipolaAux)) {
                            return {
                                value: codigoDivipolaAux,
                                symbol: new SimpleFillSymbol({
                                    color: [245, 245, 245, 1],  // Gris muy claro
                                    outline: {
                                        color: [211, 211, 211],
                                        width: 1
                                    }
                                }),
                                label: `Municipio ${codigoDivipolaAux}`
                            };
                        } else {
                            if (divipolaCantidad.some(divipola => divipola.codigoDivipola === codigoDivipolaAux)) {
                                return {
                                    value: codigoDivipolaAux,
                                    symbol: new SimpleFillSymbol({
                                        color: colorsRange(listaCantidades, cantidad, codigoDivipolaAux),
                                        outline: {
                                            color: [211, 211, 211],
                                            width: 1
                                        }
                                    }),
                                    label: `Municipio ${codigoDivipolaAux}`
                                };
                            } else {
                                return {
                                    value: codigoDivipolaAux,
                                    symbol: new SimpleFillSymbol({
                                        color: [255, 255, 255, 1],  // Gris más claro
                                        outline: {
                                            color: [211, 211, 211, .2],
                                            width: 1
                                        }
                                    }),
                                    label: `Municipio ${codigoDivipolaAux}`
                                };
                            }
                        }
                    }),
            });
            cargarCapaMapa(layerType, "");
            if (view && view.popup && typeof view.popup.close === 'function') {
                view.popup.close();
            }
        } catch (error) {
            handleError(error);
        }
    }

    const crearBotonesZoom = () => {
        //eliminar botones si ya existen
        const existingButtons = document.querySelectorAll(".esri-widget--button");
        existingButtons.forEach(button => button.remove());

        // Verificar el estado de los filtros para determinar qué botones mostrar
        const hasDepartamento = DEFAULT_FILTER.codigoDivipolaDpto !== "";
        const hasMunicipio = DEFAULT_FILTER.codigoDivipolaMpio !== "";
        
        // Si no hay departamento ni municipio seleccionado, no mostrar botones
        if (!hasDepartamento && !hasMunicipio) {
            return;
        }

        // Crear y agregar botón de zoom in (siempre deshabilitado visualmente)
        const zoomInButton = document.createElement("button");
        // innerHTML is only used with trusted/generated content, not user input (safe from XSS)
        zoomInButton.innerHTML = "+";
        zoomInButton.className = "esri-widget--button esri-widget esri-interactive";
        zoomInButton.style.position = "absolute";
        zoomInButton.style.top = "10px";
        zoomInButton.style.left = "10px";
        zoomInButton.style.backgroundColor = "#cccccc"; // Gris para aparecer deshabilitado
        zoomInButton.style.border = "1px solid #cccccc";
        zoomInButton.style.cursor = "not-allowed"; // Cursor de no permitido
        zoomInButton.style.opacity = "0.6"; // Más transparente para parecer deshabilitado
        // No agregar event listener para mantenerlo deshabilitado funcionalmente

        // Crear y agregar botón de zoom out solo si hay algo seleccionado para hacer zoom out
        if (hasDepartamento || hasMunicipio) {
            const zoomOutButton = document.createElement("button");
            // innerHTML is only used with trusted/generated content, not user input (safe from XSS)
            zoomOutButton.innerHTML = "-";
            zoomOutButton.className = "esri-widget--button esri-widget esri-interactive";
            zoomOutButton.style.position = "absolute";
            zoomOutButton.style.top = "50px";
            zoomOutButton.style.left = "10px";
            zoomOutButton.style.backgroundColor = "#ffffff";
            zoomOutButton.style.border = "1px solid #cccccc";
            zoomOutButton.style.cursor = "pointer";
            zoomOutButton.addEventListener("click", () => {
                zoomOut();
            });
            view.ui.add(zoomOutButton, "top-left");
        }

        view.ui.add(zoomInButton, "top-left");
    };

    const zoomOut = () => {
        if (!zooming) {
            if (DEFAULT_FILTER.codigoDivipolaMpio != "") {
                DEFAULT_FILTER.codigoDivipolaMpio = "";
                DEFAULT_FILTER.codigoDivipolaPdetMunicipio = "";
                consecutivoReact++;
                zooming = true;
                deleteAllHighlights();
                setCodigoDivipola(consecutivoReact.toString());
                recargarDatos();
            }
            else {
                if (DEFAULT_FILTER.codigoDivipolaDpto != "") {
                    DEFAULT_FILTER.codigoDivipolaMpio = "";
                    DEFAULT_FILTER.codigoDivipolaPdetMunicipio = "";
                    DEFAULT_FILTER.codigoDivipolaDpto = "";
                    consecutivoReact++;
                    zooming = true;
                    deleteAllHighlights();
                    setCodigoDivipola(consecutivoReact.toString());
                    recargarDatos();
                }
            }
        }
    }

    const centerMap = (view: __esri.MapView, featureLayer: FeatureLayer) => {
        var todosDivipolasCenter = codigosDivipolasGrises;
        const fronteras = divipolaCantidad.map(divipola => divipola.codigoDivipola);
        //add in fronteras todosDivipolasCenter
        fronteras.push(...todosDivipolasCenter);
        //fronteras.splice(fronteras.indexOf("88"), 1);
        if (fronteras.length > 0) {
            view.when(() => {
                featureLayer.queryFeatures({
                    where: `${layerConfig[layerType].fieldCode} IN (${fronteras.map(f => `'${f}'`).join(',')})`,
                    returnGeometry: true
                }).then((results) => {
                    if (results.features.length > 0) {
                        view.goTo({
                            target: results.features,
                            zoom: 10
                        }).catch((error) => {
                            handleError(error);
                        });
                    }
                });
            });
        }
    };

    const togglePdetLayer = () => {
        deleteAllHighlights();
        limpiarFiltros();
        if (pdetLayerVisible) {
            DEFAULT_FILTER.esPDET = "";
        }
        else {
            DEFAULT_FILTER.esPDET = "1";
        }
        setPdetLayerVisible(!pdetLayerVisible);
        consecutivoReact++;
        setCodigoDivipola(consecutivoReact.toString());
    };

    const toggleInternosLayer = () => {
        deleteAllHighlights();
        limpiarFiltros();
        if (internosLayerVisible) {
            DEFAULT_FILTER.internos = "";
        }
        else {
            DEFAULT_FILTER.internos = "1";
        }
        setInternosayerVisible(!internosLayerVisible);
        consecutivoReact++;
        setCodigoDivipola(consecutivoReact.toString());
    }

    const showHidenLayers = () => {
        setShowLayers(!showLayers);
    }

    const handleButtonClick = () => {
        if (primeraInfancia) {
            // Redirigir la página padre (no el iframe) a la URL territorial
            try {
                window.parent.location.href = 'http://sinergia.dnp.gov.co/territorial';
            } catch (error) {
                // Fallback si no se puede acceder a la página padre (por restricciones de seguridad)
                window.top!.location.href = 'http://sinergia.dnp.gov.co/territorial';
            }
        } else {
            showHidenLayers();
        }
    }

    useEffect(() => {
        map = new ArcGISMap({
            // basemap: 'streets-navigation-vector'
        });
        view = new MapView({
            container: 'mapDivDetalles',
            map: map,
            center: [-72.48175, 4.00971], // Coordenadas de Bogotá, Colombia
            zoom: 5,
            ui: {
                components: [] // Esto elimina los controles de zoom de la interfaz de usuario
            },
            highlightOptions: {
                color: new Color([255, 255, 0, 0.6]), // Amarillo semitransparente
                fillOpacity: 0.3,
                haloOpacity: 0.8
            }
        });
        if (view.popup) {
            view.popup.dockOptions = {
            // Disable the dock button so users cannot undock the popup
            buttonEnabled: false,
            // Dock the popup when the size of the view is less than or equal to 600x1000 pixels
                breakpoint: {
                    width: 4000,
                    height: 4000
                }
            };
        }
        renderer = rendererDefault;
        eventsOnMap();
    }, []);

    useEffect(() => {
        console.log(indicador);
        recargarDatos();
    }, [pdetLayerVisible, codigoDivipola]);

    useEffect(() => {
        console.log(indicador);
        DEFAULT_FILTER.internos = "";
        if (indicador.esFichaDepartamental == false) {
            DEFAULT_FILTER.internos = "1";
        }
        recargarDatos();
    }, [indicador]);

    useEffect(() => {
        console.log(indicador);
        if (view && view.popup && typeof view.popup.close === 'function') {
            view.popup.close();
        }
        recargarDatos();
        if (view && view.popup && typeof view.popup.close === 'function') {
            view.popup.close();
        }
    }, [filtrar]);

    return (
        <div style={{ flexGrow: 1, height: HEIGHT_BODY, position: 'relative' }}>
            <div id="mapDivDetalles" style={{ position: 'absolute', left: 0, top: 0, width: "100%", height: HEIGHT_BODY }} >
                {!cargado && (
                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                        <div className="spinner-border" role="status">

                        </div>
                    </div>
                )}
            </div>
            <div id="capas" style={{ zIndex: 9999, position: 'absolute', left: 50, bottom: 10, height: "auto", width: "200px", backgroundColor: "transparent", border: '1px solid #f0f0f0', borderRadius: '10px 10px 0 0' }}>
                <div onClick={handleButtonClick} style={{ padding: '5px', cursor: 'pointer', backgroundColor: '#36c', color: '#ffffff', textAlign: 'center', borderRadius: '10px 10px 10px 10px', fontWeight: 'normal', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ marginRight: '5px' }}>{primeraInfancia ? <FaUpload /> : (showLayers ? <FaDownload /> : <FaUpload />)}</span>
                    <i className="fa-solid fa-upload me-2"></i>
                    {primeraInfancia ? 'Ir a Territorial' : 'Capas geográficas'}
                </div>
                {showLayers && (
                    <div style={{ padding: '10px', backgroundColor: "white" }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>Capa PDET</span>
                            <input type="checkbox" checked={pdetLayerVisible} onChange={togglePdetLayer} />
                        </div>
                        <div style={{ display: 'none', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px', visibility: 'hidden' }}>
                            <span>Capa Datos Internos</span>
                            <input type="checkbox" checked={internosLayerVisible} onChange={toggleInternosLayer} />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MapaMain;